import FarmFaceViz from "./src";

export default FarmFaceViz;
